<div class="pnl-calendar-month">
    <div class="pnl-month-title">
        <p>{{monthLabel}}</p>
    </div>
    <div class="pnl-dates">
        <table>
          <tr>
            <th>S</th>
            <th>M</th>
            <th>T</th>
            <th>W</th>
            <th>T</th>
            <th>F</th>
            <th>S</th>
          </tr> 
          <tr class="tr-week"  *ngFor="let week of weeks"  >
              <td class="tc-day" [ngClass]="{'this-month' : day.isThisMonth, 'selected' : isSelected(day), 'past-date': day.isPast}"  *ngFor="let day of week"  >
                <span (click)="toggleDay(day)">{{day.day}}</span>
              </td>
          </tr>
        </table>
       
    </div>
</div>